<template>
  <div class="logout-page">
    <van-nav-bar title="退出登录" left-arrow @click-left="$router.go(-1)" />

    <div class="logout-body">
      <div class="logout-card">
        <div class="logout-icon">
          <van-icon name="warning-o" size="56" color="#ff6b35" />
        </div>
        <h3>确定要退出登录吗？</h3>
        <p>退出后您需要重新登录才能查看个人信息和购物车</p>

        <div class="logout-btns">
          <van-button block round plain type="default" @click="$router.go(-1)">再想想</van-button>
          <van-button block round type="danger" :loading="exiting" @click="confirmLogout">确定退出</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'Logout',
  data () {
    return {
      exiting: false
    }
  },
  methods: {
    async confirmLogout () {
      this.exiting = true
      try {
        await this.$store.dispatch('user/logOut')
        Toast.success('已安全退出')
        // 使用 replace 跳转，防止点击返回键回到已退出的页面
        this.$router.replace('/home')
      } catch (e) {
        Toast('退出失败，请稍后重试')
        this.exiting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.logout-page {
  min-height: 100vh;
  background: #f7f7f7;

  .logout-body {
    padding: 40px 20px;

    .logout-card {
      background: #fff;
      border-radius: 12px;
      padding: 40px 24px;
      text-align: center;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

      .logout-icon {
        margin-bottom: 16px;
      }

      h3 {
        font-size: 18px;
        color: #1a1a2e;
        margin: 0 0 10px;
      }

      p {
        font-size: 13px;
        color: #999;
        margin: 0 0 30px;
        line-height: 1.6;
      }

      .logout-btns {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .van-button {
          height: 44px;
        }
      }
    }
  }
}
</style>
